var _g, _path, _g2, _path2, _path3, _path4, _g3, _path5, _path6, _circle, _circle2, _path7, _path8, _path9, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageNoMessageIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 146 117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 68.18,
    cy: 94.94,
    rx: 56.212,
    ry: 10.844,
    fill: "#FFC26F",
    fillOpacity: 0.35
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.799 116.585c32.194 0 58.292-26.099 58.292-58.293S100.993 0 68.799 0 10.506 26.098 10.506 58.292s26.099 58.293 58.293 58.293Z",
    fill: "url(#b)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.627 39.45 67.674 74.31 17.722 39.45 63.449 7.524a7.393 7.393 0 0 1 8.454 0l9.122 6.377 2.388 1.659L107.46 32.35l2.534 1.78 7.633 5.319Z",
    fill: "url(#d)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m59.552 68.642-41.83 29.744V39.45l41.83 29.193Z",
    fill: "url(#e)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m75.8 68.642 41.831 29.744V39.45l-41.83 29.193Z",
    fill: "url(#f)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m17.722 98.386 45.673-32.472a7.38 7.38 0 0 1 8.562 0l45.67 32.472H17.722Z",
    fill: "url(#g)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.523 47.238a87.284 87.284 0 0 0 29.477 7.9c-1.38 3.207-11.185 19.266-40.294 32.497-.787.122-18.964-8.334-28.939-14.133.34.484 30.985-10.792 39.756-26.264Z",
    fill: "url(#i)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110.806 55.223a1.666 1.666 0 0 1 1.463-.216l16.247 5.256a.863.863 0 0 1 .397 1.375 1.187 1.187 0 0 1-1.297.363l-16.661-5.706a.606.606 0 0 1-.149-1.072ZM106.256 59.55a1.534 1.534 0 0 1 1.539-.336L119.043 63a.747.747 0 0 1 .338 1.182c-.272.33-.719.458-1.124.32l-11.799-4.017a.558.558 0 0 1-.202-.935ZM101.58 63.141a1.58 1.58 0 0 1 1.526-.251l12.956 4.709c.508.184.661.83.29 1.223-.284.3-.72.404-1.109.261l-13.502-4.955a.574.574 0 0 1-.161-.987ZM91.062 70.327a1.44 1.44 0 0 1 1.58-.38l7.405 2.826a.735.735 0 0 1 .329 1.124 1.01 1.01 0 0 1-1.179.343l-7.936-3.074a.523.523 0 0 1-.199-.84ZM95.895 66.49c.439-.275.98-.332 1.465-.154l17.06 6.237c.545.2.677.91.24 1.292a1.05 1.05 0 0 1-1.054.195l-17.598-6.483a.609.609 0 0 1-.113-1.087Z",
    fill: "#FDF4E6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.722 13.838a2.434 2.434 0 1 1-4.869 0 2.434 2.434 0 0 1 4.869 0Z",
    stroke: "url(#j)",
    strokeWidth: 1.328
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.345,
    cy: 104.014,
    r: 2.434,
    stroke: "url(#k)",
    strokeWidth: 1.328
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.147,
    cy: 108.882,
    r: 2.434,
    stroke: "url(#l)",
    strokeWidth: 1.328
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.607 16.228c.261-1.084 1.803-1.084 2.065 0l.88 3.648c.094.388.397.69.784.784l3.648.88c1.084.262 1.084 1.804 0 2.066l-3.648.88c-.387.094-.69.396-.783.784l-.881 3.648c-.262 1.084-1.804 1.084-2.065 0l-.881-3.648a1.062 1.062 0 0 0-.783-.784l-3.649-.88c-1.084-.262-1.084-1.804 0-2.066l3.649-.88c.387-.094.69-.396.783-.784l.88-3.648Z",
    fill: "url(#m)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M125.294 93.215c.262-1.084 1.804-1.084 2.065 0l.881 3.648c.094.387.396.69.783.783l3.649.881c1.084.262 1.084 1.804 0 2.065l-3.649.881a1.064 1.064 0 0 0-.783.783l-.881 3.649c-.261 1.084-1.803 1.084-2.065 0l-.881-3.649a1.061 1.061 0 0 0-.783-.783l-3.648-.881c-1.084-.261-1.084-1.803 0-2.065l3.648-.88a1.06 1.06 0 0 0 .783-.784l.881-3.648Z",
    fill: "url(#n)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.148 84.676a.885.885 0 0 1 .966 1.19l-1.64 4.297a.885.885 0 0 1-1.515.242l-2.9-3.57a.885.885 0 0 1 .547-1.432l4.542-.727Z",
    fill: "url(#o)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M127.052 40.871a.885.885 0 0 1 1.097-1.07l4.429 1.243a.886.886 0 0 1 .379 1.486l-3.292 3.213a.885.885 0 0 1-1.476-.415l-1.137-4.457Z",
    fill: "url(#p)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 68.349,
    y1: -18.981,
    x2: 69.543,
    y2: 185.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF4E6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDF4E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 67.674,
    y1: 6.197,
    x2: 67.674,
    y2: 74.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF4E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDF4E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 38.637,
    y1: 39.449,
    x2: 38.637,
    y2: 98.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF4E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC26F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 96.716,
    y1: 39.449,
    x2: 96.716,
    y2: 98.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF4E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC26F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 67.674,
    y1: 64.546,
    x2: 67.674,
    y2: 98.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC26F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC26F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 133.487,
    y1: 65.218,
    x2: 88.136,
    y2: 56.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF4E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 99.479,
    y1: 11.902,
    x2: 109.162,
    y2: 20.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC26F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 24.537,
    y1: 102.078,
    x2: 34.219,
    y2: 110.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC26F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 99.338,
    y1: 106.946,
    x2: 109.02,
    y2: 115.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC26F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 37.639,
    y1: 11.95,
    x2: 37.639,
    y2: 33.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC26F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC26F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 126.327,
    y1: 88.937,
    x2: 126.327,
    y2: 110.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC26F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC26F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 13.662,
    y1: 84.433,
    x2: 6.792,
    y2: 90.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC26F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC26F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 126.673,
    y1: 39.385,
    x2: 132.856,
    y2: 45.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC26F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC26F"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0.903,
    y: 73.031,
    width: 134.554,
    height: 43.819,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.533,
    result: "effect1_foregroundBlur_11070_2121"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 15.951,
    y: 6.197,
    width: 103.446,
    height: 71.654,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.77
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.885
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11070_2121"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11070_2121",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "h",
    x: 61.559,
    y: 46.353,
    width: 84.282,
    height: 55.447,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.683,
    dy: 6.639
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.762
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.021441 0 0 0 0 0.168056 0 0 0 0 0.395833 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11070_2121"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11070_2121",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageNoMessageIllustration);
export default __webpack_public_path__ + "static/media/image_no_message_illustration.e5d179d1.svg";
export { ForwardRef as ReactComponent };